import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';

export const EmspBoChargingSessionListFilterFormStep1Controller =
  (): React.JSX.Element => {
    // RENDER //////////////////////////////////////////////////////////////////

    return (
      <Stack
        direction="row"
        justifyContent="stretch"
        alignItems="stretch"
        flex={1}
        gap={GapEnum.XL}>
        <Stack
          direction="column"
          flex={1}
          alignItems="stretch"
          gap={GapEnum.XL}>
          <div />
        </Stack>
      </Stack>
    );
  };
